const reviews = [
  {
    name: "Daniel W.",
    location: "North Pole, AK",
    rating: 5,
    text: "I needed a passport for a sudden trip to Canada for work. Living near Fairbanks means Seattle is basically out of the question. FPC processed my renewal in 6 days — absolutely saved my trip.",
  },
  {
    name: "Amanda J.",
    location: "College, Fairbanks AK",
    rating: 5,
    text: "University of Alaska student here. FPC helped me get a passport renewal while living in the dorms. They walked me through every step and had it back in a week. Great communication the whole time.",
  },
  {
    name: "Tyler M.",
    location: "Fort Wainwright, AK",
    rating: 5,
    text: "Military family at Wainwright. We needed passports for an overseas trip and FPC made it straightforward even with our busy schedule. Got back in 7 days. Highly recommend to other soldiers and families.",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Fairbanks Travelers Say
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from real Fairbanks residents who used Fast Passport Center.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(r.rating)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-5 italic">&ldquo;{r.text}&rdquo;</p>
              <div>
                <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                <p className="text-gray-400 text-xs">{r.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}